import { Pagination } from 'antd';
import Table from 'components/Table';
import { MobileTableType } from 'components/Table/types';
import deviceSizes from 'constants/deviceSizes';
import usStates from 'constants/usStates';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import useWindowSize from 'hooks/useWindowSize';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { ILocationTableMapper } from 'routes/ManageLocations/types';
import { WithSlideInComponentStyled } from 'routes/Users/components/UsersList/styled';
import { ILocation } from 'types/location';
import { CompanyRoleEnum } from 'types/user';
import { formatPhoneNumber, getNewQueryString } from 'utils';

import LocationSlideIn from '../LocationSlideIn';
import { ILocationListProps } from './types';

// const mobileConfig: IMobileTableConfig<ILocationTableMapper> = {
//   grid: [
//     ['name', 'number', 'address'],
//     ['city', 'state', 'zip'],
//   ],
// };

const LocationList: React.FC<ILocationListProps> = ({ onRowClick, refetch, meta, ...tableProps }) => {
  const history = useHistory();
  const { location: historyLocation } = history;

  const user = useCurrentLoggedInUser(); // test nha
  const { companyRole } = user;
  const isCompanyAdmin = companyRole === CompanyRoleEnum.ADMIN;
  const [selectedLocation, setSelectedLocation] = useState<ILocation>();

  const onPageChange = (page: number) => {
    const newQueryString = getNewQueryString(historyLocation.search, { page });
    history.push({
      pathname: historyLocation.pathname,
      search: newQueryString,
    });
  };

  const onContentClick = (data: ILocationTableMapper) => {
    setSelectedLocation(data.location);
  };

  const closeDrawer = () => {
    setSelectedLocation(undefined);
  };

  const mainContentConverterWhenSlideActive = (data: ILocationTableMapper) => ({
    ...data,
    state: usStates[data.state || ''],
    number: formatPhoneNumber(data.number),
  });

  const mobileThreshold = deviceSizes.numbers.sm;

  const { isMobile } = useWindowSize(mobileThreshold);

  useEffect(() => {
    if (selectedLocation)
      setSelectedLocation((l) => tableProps.dataSource?.find((s) => s?.location?.id === l?.id)?.location || l);
  }, [tableProps.dataSource]);

  return (
    <div className='w-full' style={{ padding: isMobile ? 16 : undefined }}>
      <WithSlideInComponentStyled
        activeKey={selectedLocation?.id}
        highlightActiveContent
        onContentClick={onContentClick}
        slideInProps={{
          children: <LocationSlideIn refetchLocationData={refetch} location={selectedLocation} />,
          onClose: closeDrawer,
          // visible: drawerVisibility
          title: selectedLocation?.name,
        }}
        slideInVisible={!!selectedLocation && isCompanyAdmin}
        mainContentDataWhenSlideIn={tableProps.dataSource}
        displayDataKeysWhenSlideIn={['name', 'number', 'address1', 'state']}
        mainContentDataConverter={mainContentConverterWhenSlideActive}
        renderExtraWhenSlideIn={
          <div className='gx-flex-column gx-justify-content-end gx-align-items-end gx-h-100 gx-mt-3'>
            <Pagination
              style={{ marginLeft: 15, height: 'auto' }}
              total={meta?.itemCount}
              defaultCurrent={1}
              onChange={onPageChange}
            />
          </div>
        }>
        <Table
          {...tableProps}
          onRow={
            isCompanyAdmin
              ? (record) => ({
                  onClick: () => {
                    onRowClick?.(record.location as ILocation);
                    onContentClick(record);
                  },
                })
              : undefined
          }
          nullRender='--'
          // mobileConfig={mobileConfig}
          mobileDesignType={MobileTableType.RESPONSIVE_TABLE}
          widthThreshold={mobileThreshold}
          className='gx-table-responsive'
        />
      </WithSlideInComponentStyled>
    </div>
  );
};
export default React.memo(LocationList);
